import api from 'Application/api/api';

const createTemplateGroup = (data, cancelToken = null) =>
    api.post('project-manager/template-groups', data, { cancelToken });

export default createTemplateGroup;
